import BasicPage from '~/mixins/simply-descriptions/';
import { Component, Vue } from 'nuxt-property-decorator';
import { Descriptions } from '~/types/catalog';

@Component({
    mixins: [BasicPage]
})
export default class extends Vue {
    meta: Descriptions;
}
